import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import TopGrid from '../components/TopGrid.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/gettop/:office/:width?', component: TopGrid, props: true },

  {
    path: '/',
    name: 'Home',
    component: Home,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
